import { useQuery } from '@tanstack/react-query';
import { authenticatePlanGrid } from 'api/services';
import { BrokenLinkIcon } from 'library/icons';
import { CircularProgress } from 'library/loaders';
import { IllustrationView } from 'modules/shared/features/illustration';
import { Link, Navigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const constructPlangridRedirectUrl = () => {
    return window.location.origin + '/plangrid-authorization';
};

const PlangridIllustration = () => {
    return (
        <div className="flex items-center gap-5">
            <img className="h-10" src="/logos/logo.png" alt="progressCenter" />
            <BrokenLinkIcon />
            <img className="h-10" src="/plugins-images/plangrid.svg" alt="PlanGrid" />
        </div>
    );
};

const PlanGridAuthorizationPage = () => {
    const [searchParams] = useSearchParams();

    const code = searchParams.get('code');
    const state = searchParams.get('state');

    const redirectUri = constructPlangridRedirectUrl();

    const { token, pluginId } = JSON.parse(decodeURIComponent(state));

    const planGridQuery = useQuery(['planGridAuthorization', code, redirectUri, token], () =>
        authenticatePlanGrid(token, { code, redirectUri })
    );

    if (planGridQuery.isSuccess) {
        toast.success('PlanGrid account linked successfully.');

        return <Navigate to={`/plugins/${pluginId}/plangrid?tab=link-account`} replace />;
    }

    if (planGridQuery.isLoading) {
        return (
            <section>
                <div className="fixed top-0 left-0 flex flex-col items-center justify-center h-screen w-full bg-card-color">
                    <div className="flex items-center justify-center w-14 h-14 rounded-lg text-primary ">
                        <CircularProgress size={32} />
                    </div>
                </div>
            </section>
        );
    }

    if (planGridQuery.error) {
        return (
            <IllustrationView
                className="justify-center h-screen"
                illustration={<PlangridIllustration />}
                title="PlanGrid Authorization Failed"
                message={
                    <>
                        We couldn’t connect to your PlanGrid account. Please check your credentials or try again.
                        <div className="mt-2">
                            <Link to="/" replace className="text-primary font-medium cursor-pointer">
                                Back to home
                            </Link>
                        </div>
                    </>
                }
            />
        );
    }
};

export default PlanGridAuthorizationPage;
